{
    "component-card-search-list.empty-state.title.non-final": "<strong>Yhdistä tämä säilö ohjelmistokomponenttiin</strong>",
    "component-card.add-chat-channel": "Lisää chat-kanava",
    "component-card.chat-channels": "Chat-kanavat",
    "component-card.expander.show-more-link": "Näytä vielä {formattedCount}"
}
